<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {

  }
</script>

<style lang="scss">
body{
  padding: 0;
  margin:0;
 	-webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  overflow-x: hidden;
}
@media screen and (max-width: 1200px) {
	body{
		overflow-x: scroll;
	}
}
</style>





